/**
 * Appium에서 accessibilityIdentifier에 띄어쓰기가 들어가면 인식이 잘 안되는 문제가 있어 띄어쓰기 미사용
 * iOS Accessibility.swift와 동일한 패턴
 */

const createQueryString = (
  items: Record<string, string | number | undefined | null>,
): string => {
  const params = Object.entries(items)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return params;
};

export const Accessibility = {
  Common: {
    backButton: '뒤로가기버튼',
    clearSearchKeywordButton: '검색어삭제버튼',
    searchField: '검색필드',
  },
  Search: {
    recentKeywordListItem: (keyword: string, index: number): string => {
      const queryString = createQueryString({
        TITLE: keyword,
        LIST_INDEX: index,
      });
      return `최근검색어리스트?${queryString}`;
    },
    recommendKeywordListItem: (keyword: string, index: number): string => {
      const queryString = createQueryString({
        TITLE: keyword,
        LIST_INDEX: index,
      });
      return `추천검색어리스트?${queryString}`;
    },
    popularKeywordListItem: (keyword: string, index: number): string => {
      const queryString = createQueryString({
        TITLE: keyword,
        LIST_INDEX: index,
      });
      return `인기검색어리스트?${queryString}`;
    },
  },
} as const;